export default {
    data () {
        return {
            showCourseInfo: false,
            showSlider: false
        }
    },
    methods: {
        onAnimationEnd (event) {
            if (event.animationName.includes('slideOut')) {
                this.showSlider = false
            }
        },
        showCourseInfoDiv () {
            this.showCourseInfo = !this.showCourseInfo
            this.showSlider = true
        }
    }
}
